export class SolicitudDocumentosCpeViewModel {
    public Id: number;
    public IdEstado = 0;
    public IdEstadoDescripcion: string;
    public Codigo: string;
    public TDocumentoCertificadoPrevioExCollection: TDocumentoCertificadoPrevioExViewModel[];
}
export class TDocumentoCertificadoPrevioExViewModel {
    public Id: number;
    public IdCertPrevioEx: number;
    public IdPerfilUsuarioDescription: string;
    public IdPerfilUsuario: number;
    public Texto = '';
    public Fecha: Date;
    public NombreArchivo: string;
    public Size: number;
    public CodigoStorage = '';
    public OldCodigoStorageCollection: string[] | undefined = [];
    public IdEstado: number;
    public IdEstadoDescripcion: string;
    public Codigo: string;
    public IdUsuario: number;
}
